import { call, put, takeEvery } from "redux-saga/effects"

import { GET_DEFENSES, ADD_NEW_DEFENSE, UPDATE_DEFENSE, DELETE_DEFENSE } from "./actionTypes";
import {
    getDefensesSuccess,
    getDefensesFail,
    addDefenseSuccess,
    addDefenseFail,
    updateDefenseSuccess,
    updateDefenseFail,
    deleteDefenseSuccess,
    deleteDefenseFail,
   
} from "./actions"

import {
    getDefenses,
    addNewDefense,
    updateDefense,
    deleteDefense,
   
} from "helpers/defenses/defenses_backend_helper";
import { toast } from "react-toastify";

function* fetchDefenses() {
    try {
        const response = yield call(getDefenses)

        yield put(getDefensesSuccess(response))
    } catch (error) {
        yield put(getDefensesFail(error))
    }
}

function* onAddNewDefense({ payload }) {
    try {

        
        const response = yield call(addNewDefense, payload)

        console.log("RESPONSE:", response);
        yield put(addDefenseSuccess(response.defense))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addDefenseFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateDefense({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateDefense, payload)
        yield put(updateDefenseSuccess(response.intership))
        toast.success(response.data.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateDefenseFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteDefense({ payload: data }) {

    try {
        const response = yield call(deleteDefense, data)
        yield put(deleteDefenseSuccess(response.classRoomId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteDefenseFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* defenseSaga() {
    yield takeEvery(GET_DEFENSES, fetchDefenses)
    yield takeEvery(ADD_NEW_DEFENSE, onAddNewDefense)
    yield takeEvery(UPDATE_DEFENSE, onUpdateDefense)
    yield takeEvery(DELETE_DEFENSE, onDeleteDefense)
}

export default defenseSaga;